import React from 'react';
import styleable from 'react-styleable';
import css from './activity-mastery.scss';
import ConnectedSubHeading from '../../components/sub-heading/sub-heading';
import ConnectedReportRoutes from '../report-routes/report-routes';
import ConnectedAllClasses from './all-classes/all-classes';
import ConnectedSingleClass from './single-class/single-class';
import ConnectedStudent from './student/student';
import EmptyState from '../../components/empty-state/empty-state';
import EMPTY_STATE_VARIANTS from '../../components/empty-state/empty-state-constants';

const ActivityMastery = () => {
    const routeComps = {
        allClasses: ConnectedAllClasses,
        singleClass: ConnectedSingleClass,
        student: ConnectedStudent
    };

    return (
        <div className={css.component}>
            <EmptyState variant={EMPTY_STATE_VARIANTS.NO_STUDENTS}>
                <ConnectedReportRoutes components={routeComps}>
                    <ConnectedSubHeading isExportEnabled />
                </ConnectedReportRoutes>
            </EmptyState>
        </div>
    );
};

export default styleable(css)(ActivityMastery);



// WEBPACK FOOTER //
// ./containers/activity-mastery/activity-mastery.js